var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    rx: 62,
    fill: "#E5E5E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 60.75C60.3424 60.75 58.7527 60.0915 57.5806 58.9194C56.4085 57.7473 55.75 56.1576 55.75 54.5C55.75 52.8424 56.4085 51.2527 57.5806 50.0806C58.7527 48.9085 60.3424 48.25 62 48.25C63.6576 48.25 65.2473 48.9085 66.4194 50.0806C67.5915 51.2527 68.25 52.8424 68.25 54.5C68.25 55.3208 68.0883 56.1335 67.7742 56.8918C67.4602 57.6501 66.9998 58.3391 66.4194 58.9194C65.8391 59.4998 65.1501 59.9602 64.3918 60.2742C63.6335 60.5883 62.8208 60.75 62 60.75ZM62 37C57.3587 37 52.9075 38.8437 49.6256 42.1256C46.3437 45.4075 44.5 49.8587 44.5 54.5C44.5 67.625 62 87 62 87C62 87 79.5 67.625 79.5 54.5C79.5 49.8587 77.6563 45.4075 74.3744 42.1256C71.0925 38.8437 66.6413 37 62 37Z",
    fill: "#959BA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationNotFound);
export default __webpack_public_path__ + "static/media/LocationNotFound.b9c87f9c7b95f431a92e35d415ac2afd.svg";
export { ForwardRef as ReactComponent };